<div class="flex h-full">
  <!-- Left side - Image and branding (same as login) -->
  <div class="hidden md:flex md:w-2/3 bg-gray-100 relative overflow-hidden">
    <!-- Full image background -->
    <img src="assets/images/login.jpg" alt="Background" class="absolute object-cover w-full h-full">

    <!-- Strategic gradient overlay for better text readability -->
    <div class="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-black/0"></div>

    <!-- Content positioned in the most readable area -->
    <div class="absolute inset-x-0 bottom-0 p-12 pr-0 z-10">
      <div class="flex items-center flex-row gap-4 mb-2">
        <img src="assets/images/app-logo.webp" class="h-10 w-10">
        <h1 class="text-5xl font-bold text-white tracking-tight" translate="no">Mr. Kresz</h1>
      </div>
      <p class="text-xl text-white/90 max-w-md">Üdvözlünk a partnerközösségben!</p>
    </div>
  </div>

  <!-- Right side - Forgot Password form -->
  <div class="w-full md:w-1/2 flex items-center justify-center p-8 bg-white">
    <div class="max-w-md w-full">
      <!-- Mobile logo only -->
      <div class="flex flex-col items-center md:hidden mb-10">
        <img src="assets/images/app-logo.webp" class="h-16 mb-2">
        <div class="text-xl font-bold"><span translate="no">Mr. Kresz</span> partner</div>
      </div>

      <!-- Initial State: Show Form -->
      <ng-container *ngIf="state === ForgotPasswordState.Initial || state === ForgotPasswordState.Loading">
        <h2 class="text-2xl font-bold mb-2 text-center">Elfelejtett jelszó</h2>
        <p class="text-gray-600 text-center mb-6">Add meg az e-mail címed és küldünk egy jelszó visszaállítási linket.</p>

        <form class="w-full" [formGroup]="forgotPasswordFG">
          <div class="mb-6">
            <mat-form-field class="w-full">
              <mat-label>E-mail cím</mat-label>
              <input matInput formControlName="emailFC" type="email" />
              <mat-error *ngIf="emailFC.hasError('required')">Kötelező mező!</mat-error>
              <mat-error *ngIf="emailFC.hasError('email') && !emailFC.hasError('required')">Érvénytelen e-mail cím!</mat-error>
            </mat-form-field>
          </div>

          <div class="flex flex-col gap-3">
            <button
              type="button"
              class="app-button w-full"
              (click)="requestPasswordReset()"
              [disabled]="isLoading"
              [class.button-loading]="isLoading">
              Jelszó visszaállítása
            </button>

            <button
              type="button"
              class="text-primary hover:underline text-center"
              (click)="goToLogin()"
              [disabled]="isLoading">
              Vissza a bejelentkezéshez
            </button>
          </div>
        </form>
      </ng-container>

      <!-- Success State -->
      <ng-container *ngIf="state === ForgotPasswordState.Success">
        <div class="text-center">
          <div class="mb-6">
            <mat-icon class="text-green-500 !text-6xl !w-16 !h-16">check_circle</mat-icon>
          </div>
          <h2 class="text-2xl font-bold mb-4">Kérés elküldve</h2>
          <p class="text-gray-600 mb-6">
            Ha a megadott email cím regisztrálva van, hamarosan küldünk egy jelszó visszaállítási linket.
          </p>
          <button
            class="app-button w-full"
            (click)="goToLogin()">
            Vissza a bejelentkezéshez
          </button>
        </div>
      </ng-container>

      <!-- Rate Limited State -->
      <ng-container *ngIf="state === ForgotPasswordState.RateLimited">
        <div class="text-center">
          <div class="mb-6">
            <mat-icon class="text-orange-500 !text-6xl !w-16 !h-16">schedule</mat-icon>
          </div>
          <h2 class="text-2xl font-bold mb-4">Túl sok kérés</h2>
          <p class="text-gray-600 mb-6">
            Túl sok kérés. Kérjük, próbáld újra később.
          </p>
          <div class="flex flex-col gap-3">
            <button
              class="app-button w-full"
              (click)="resetForm()">
              Újrapróbálkozás
            </button>
            <button
              type="button"
              class="text-primary hover:underline text-center"
              (click)="goToLogin()">
              Vissza a bejelentkezéshez
            </button>
          </div>
        </div>
      </ng-container>

      <!-- Error State -->
      <ng-container *ngIf="state === ForgotPasswordState.Error">
        <div class="text-center">
          <div class="mb-6">
            <mat-icon class="text-red-500 !text-6xl !w-16 !h-16">error</mat-icon>
          </div>
          <h2 class="text-2xl font-bold mb-4">Hiba történt</h2>
          <p class="text-gray-600 mb-6">
            Hiba történt a kérés feldolgozása közben. Kérjük, próbáld újra később.
          </p>
          <div class="flex flex-col gap-3">
            <button
              class="app-button w-full"
              (click)="resetForm()">
              Újrapróbálkozás
            </button>
            <button
              type="button"
              class="text-primary hover:underline text-center"
              (click)="goToLogin()">
              Vissza a bejelentkezéshez
            </button>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
